export const getLoading = (state: any) => state.common.loading;
export const getSaving = (state: any) => state.common.saving;
export const getError = (state: any) => state.common.error;
export const getUserCurrency = (state: any) => state.common.userCurrency;
